module.exports = __webpack_public_path__ + "img/Avatar-58.897da6f0.svg";